import { Component, signal, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";

import { TranslateModule } from "@ngx-translate/core";
import { MsalService } from "@azure/msal-angular";
import { environment } from "src/environments/environment";

@Component({
    selector: "app-sign-in-loader",
    templateUrl: "./sign-in-loader.component.html",
    styleUrls: ["./sign-in-loader.component.scss"],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule],
})
export class SignInLoaderComponent implements OnInit {
    // === Dependencies ===
    private readonly authService = inject(MsalService);

    // === Public Properties ===
    public readonly environment = environment;
    public readonly showLogout = signal(false);

    // === Lifecycle ===
    public ngOnInit(): void {
        setTimeout(() => {
            this.showLogout.set(true);
        }, 15000);
    }

    // === Public Methods ===
    public logout(): void {
        this.authService.logoutRedirect();
    }
}
